module.exports = __webpack_public_path__ + "static/media/house-pin.7183b876.svg";